
















































































































































































































































































































import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import {
  CommonsStore, Payload, AdvertisementsStore, AuthorizationStore, MyaaffiliateStore,
} from '@samclick-store-factory';
import SamclickMixins from '@/utils/mixins';
import { getPercentageRate, roundMoneyAmount, toMoney, sortString } from '@/utils/common-utils';
import {
  DEFAULT_FORMAT, getEndDayOfDate, getStartOfCurrentMonth, formatDate, subtractMonthsFromDate, getStartDayOfDate, FULL_DATE_FORMAT, FULL_MONTH_FORMAT, getDateTodayIsoFormat,
} from '@/utils/date-utils';
import { BarWithLineConfig, BarWithLineSetting } from '@/components/graphs/bar/bar-with-line';
import { BasicLineConfig, BasicLineSetting } from '@/components/graphs/line/basic-line';
import { PieConfig } from '@/components/graphs/pie/pie';
import Detail from './Detail.vue';
import { _filter } from '@/plugins/lodash';

class ResultTabState {
  casino: string | number = ''

  service: number = -1

  campaign: string | number = ''

  dayPeriod: Array<string> = [getStartOfCurrentMonth(), getDateTodayIsoFormat()]

  display: number = 0

  graphType: string = 'sales_graph'

  displayColumns: Array<string> = []

  adsCategoryId: string | number = ''

  isSearching: Boolean = false

  isExporting: Boolean = false
}
@Component({
  /**
      * Imported components
      * */
  components: {
    Detail,
  },
  /**
      * Stores values
      * */
  computed: {
    ...mapState({
      campaignList: (state: any) => state.advertisements.advertisementsStore.campaignList,
      loading: (state: any) => state.myaaffiliate.myaaffiliateStore.loading,
      mereports: (state: any) => state.myaaffiliate.myaaffiliateStore.mereports,
      mereportsrows: (state: any) => state.myaaffiliate.myaaffiliateStore.mereportsrows,
      casinoreports: (state: any) => state.myaaffiliate.myaaffiliateStore.casinoreports,
    }),
  },
  data() {
    return {
      graphData: [],
      reportRows: [],
    };
  },
  /**
      * Component properties
      * */
  props: {},
})
export default class ResultTab extends mixins(SamclickMixins) {
  /**
    * Local state
    * */
  state = new ResultTabState();

  payloadTemp = {};

  activeCasinos: { id: number, code: string }[] = []

  readonly SALES_GRAPH = 'sales_graph'

  readonly FTD_GRAPH = 'ftd_graph'

  readonly CASINO_GRAPH = 'casino_graph'

  readonly BY_DAY = 0

  readonly BY_MONTH = 1

  readonly DATE_COLUMN = 'date'

  readonly VIEW_COLUMN = 'view'

  readonly CLICKS_COLUMN = 'clicks'

  readonly CLICK_RT_COLUMN = 'click_rate'

  readonly SIGNUP_COLUMN = 'signup'

  readonly SIGNUP_RT_COLUMN = 'signup_rate'

  readonly TOTAL_FTD_COLUMN = 'total_ftd'

  readonly FTD_COLUMN = 'ftd'

  readonly FTD_RT_COLUMN = 'ftd_rate'

  readonly ACTIVE_COLUMN = 'active_player'

  readonly SALES_COLUMN = 'sales'

  readonly CPA_COMM_COLUMN = 'cpa'

  readonly COMM_COLUMN = 'commission'

  readonly OTHER_COMM_COLUMN = 'other_commission'

  readonly TIER_COMM_COLUMN = 'tier_commission'

  readonly DEPOSITS_COLUMN = 'deposits'

  readonly DEPOSIT_COUNT_COLUMN = 'deposit_count'

  readonly WITHDRAWALS_COLUMN = 'withdrawals'

  readonly WITHDRAWAL_COUNT_COLUMN = 'withdraw_count'

  readonly TOTAL_COMM_COLUMN = 'total_commission'

  /**
    * Watchers
    * */
  @Watch('state.display')
  displayWatcher(displayType: number) {
    if (displayType === this.BY_DAY) {
      this.state.dayPeriod = [getStartOfCurrentMonth(), getDateTodayIsoFormat()];
    } else if (displayType === this.BY_MONTH) {
      this.state.dayPeriod = [getStartDayOfDate(subtractMonthsFromDate(7)), getEndDayOfDate()];
    }
  }

  @Watch('state.casino')
  casinoOnChanged(casino: number | string) {
    if (casino) {
      this.state.service = CommonsStore.casinoAllDescription(Number(casino)).service_id;
    } else {
      this.state.service = -1;
    }
  }

  @Watch('state.adsCategoryId')
  adsCategoryIdOnChanged(casino: number | string) {
    this.state.campaign = '';
  }

  /**
    * Methods
    * */
  search(searchFromButton: boolean = false) {
    const {
      display, dayPeriod, casino, campaign, service, adsCategoryId,
    } = this.state;
    const startDate = dayPeriod[0];
    let endDate = dayPeriod[1];
    if (display === this.BY_MONTH) {
      endDate = getEndDayOfDate(dayPeriod[1]);
    }

    endDate = `${formatDate(endDate)}T23:59:59.999Z`;

    let casino_ids: (string | number)[] = []
    if (casino !== 0 && casino !== '') {
      casino_ids = [casino]
    }

    const payload = {
      start_date: startDate,
      end_date: endDate,
      casino_ids,
      medium_id: campaign,
      monthly: display,
      affiliate_id: this.getAffiliateID,
      service_id: service > 0 ? service : '',
      advertisement_category_id: adsCategoryId,
    };

    this.payloadTemp = payload;

    if (!this.showDateRangeError()) {
      if (searchFromButton) {
        this.state.isSearching = true;
        if (casino_ids.length == 0) this.getCasinoWithDaySales();

        MyaaffiliateStore.MeReport(new Payload(payload)).then(() => {
          this.$data.graphData = this.mereports.rows;
        });

        MyaaffiliateStore.MeReportRows(new Payload(payload))
        .then(() => {
          this.$data.reportRows = this.mereportsrows;

          return MyaaffiliateStore.CasinoReport(new Payload({
            start_date: startDate,
            end_date: endDate,
            ads_category_id: adsCategoryId,
            affiliate_id: this.getAffiliateID,
          }, false));
        }).finally(() => {
          this.state.isSearching = false;
        });
      } else {
        MyaaffiliateStore.MeReport(new Payload(payload)).then(() => {
          this.$data.graphData = this.mereports.rows
          MyaaffiliateStore.CasinoReport(new Payload({
            start_date: startDate,
            end_date: endDate,
            ads_category_id: adsCategoryId,
            affiliate_id: this.getAffiliateID,
          }, false));
        });
      }
    } else {
      this.state.isSearching = false;
    }
  }

  getCasinoWithDaySales() {
    const {
      display, dayPeriod,
    } = this.state;
    const startDate = dayPeriod[0];
    let endDate = dayPeriod[1];
    if (display === this.BY_MONTH) {
      endDate = getEndDayOfDate(dayPeriod[1]);
    }

    endDate = `${formatDate(endDate)}T23:59:59.999Z`;
    this.state.casino = "";

    MyaaffiliateStore.GetCasinosWithDaySales(new Payload({
      affiliate_id: this.getAffiliateID,
      start_date: startDate,
      end_date: endDate,
    })).then((response: any) => {
      if (response.data) {
        this.activeCasinos = response.data;
      } else {
        this.activeCasinos = [];
      }
    });
  }

  arrangeByMonthData(rawData: object[]) {
    const grouped = Object.values(
      rawData.reduce((acc, curr: any) => {
        const casinoId = curr.report.casino_id;

        if (!acc[casinoId]) {
          acc[casinoId] = { casino_id: casinoId, items: [] };
        }
        acc[casinoId].items.push(curr);
        return acc;
      }, {})
    );

    return grouped;
  }

  reset() {
    this.state = new ResultTabState();
    this.$nextTick(() => {
      this.search();
    });
  }

  generateBarConfig() {
    const setting = [
      new BarWithLineSetting('bar', this.$t('label.net_revenue').toString(), 'rgb(75, 192, 192)', 'sales', 'left', true),
      new BarWithLineSetting('line', this.$t('label.hits').toString(), 'rgb(255, 99, 132)', 'clicks', 'right'),
    ];
    return new BarWithLineConfig('date', setting, this.state.display === this.BY_MONTH ? 'YYYY-MM' : DEFAULT_FORMAT);
  }

  generateLineConfig() {
    const setting = [
      new BasicLineSetting(this.$t('label.signups').toString(), 'rgb(255, 205, 86)', 'registrants'),
      new BasicLineSetting(this.$t('label.ftds').toString(), 'rgb(255, 99, 132)', 'ftd'),
      new BasicLineSetting(this.$t('label.ftd_conversion').toString(), 'rgb(75, 192, 192)', 'deposit_rate', 'right'),
    ];
    return new BasicLineConfig('date', setting, this.state.display === this.BY_MONTH ? 'YYYY-MM' : DEFAULT_FORMAT);
  }

  generatePieConfig() {
    return new PieConfig('name', 'sales', 'casino_id', true);
  }

  exportCsv() {
    this.state.isExporting = true;

    const {
      display, dayPeriod, casino, campaign, service, adsCategoryId,
    } = this.state;
    const startDate = dayPeriod[0];
    let endDate = dayPeriod[1];
    if (display === this.BY_MONTH) {
      endDate = getEndDayOfDate(dayPeriod[1]);
    }

    endDate = `${formatDate(endDate)}T23:59:59.999Z`;

    let casino_ids: (string | number)[] = []
    if (casino !== 0 && casino !== '') {
      casino_ids = [casino]
    }

    const headers = [
      this.$t('label.date'),
      this.$t('label.brand'),
      this.$t('label.impression'),
      this.$t('label.hits'),
      `${this.$t('label.click_conversion')}(%)`,
      this.$t('label.signups'),
      `${this.$t('label.signup_conversion')}(%)`,
      this.$t('label.total_ftd'),
      this.$t('label.qualified_ftd'),
      `${this.$t('label.ftd_conversion')}(%)`,
      this.$t('label.active_players'),
      this.$t('label.net_revenue'),
      `${this.$t('label.commissions')} (€)`,
      `${this.$t('label.cpa_commissions')} (€)`,
      `${this.$t('label.tier_commission')} (€)`,
      `${this.$t('label.deposits')} (€)`,
      `${this.$t('label.deposit_count')}`,
      `${this.$t('label.withdrawals')} (€)`,
      `${this.$t('label.withdrawal_count')}`,
      `${this.$t('label.total_commission')} (€)`,
    ];

    const reportRowsPayload = {
      start_date: startDate,
      end_date: endDate,
      casino_ids,
      medium_id: campaign,
      monthly: display,
      affiliate_id: this.getAffiliateID,
      service_id: service > 0 ? service : '',
      advertisement_category_id: adsCategoryId,
      is_aff_portal: true,
      headers,
    };

    if (!this.showDateRangeError()) {
      MyaaffiliateStore.exportAchievement(new Payload(reportRowsPayload)).finally(() =>{
        this.state.isExporting = false;
      });
    } else {
      this.state.isExporting = false;
    }
  }

  showDateRangeError() {
      const startDateObj = new Date(this.payloadTemp.start_date);
      const endDateObj = new Date(this.payloadTemp.end_date);
      const diffDays = Math.floor((endDateObj.getTime() - startDateObj.getTime()) / (1000 * 60 * 60 * 24)) + 1;
      if (diffDays > 92) {
          this.showAlert('Please request within a date range of 92 days/3 months or less.', this.$data.SamclickAlert.ERROR)
          this.state.isSearching = false;
          return true;
      }
      return false;
  }


  sortClickConversion(a: any, b: any) {
    const rowA = parseFloat(a.banner_displays > 0 ? getPercentageRate(a.clicks, a.banner_displays).toString() : '0');
    const rowB = parseFloat(b.banner_displays > 0 ? getPercentageRate(b.clicks, b.banner_displays).toString() : '0');

    return rowA - rowB;
  }

  sortSignUpConversion(a: any, b: any) {
    const rowA = parseFloat(a.clicks > 0 ? getPercentageRate(a.registrants, a.clicks).toString() : '0');
    const rowB = parseFloat(b.clicks > 0 ? getPercentageRate(b.registrants, b.clicks).toString() : '0');

    return rowA - rowB;
  }

  sortFTDConversion(a: any, b: any) {
    const rowA = parseFloat(a.registrants > 0 ? getPercentageRate(a.ftd, a.registrants).toString() : '0');
    const rowB = parseFloat(b.registrants > 0 ? getPercentageRate(b.ftd, b.registrants).toString() : '0');

    return rowA - rowB;
  }


  /**
    * Computed
    * */

  get graphType() {
    return [
      { id: this.SALES_GRAPH, label: 'label.chart_revenue_title' },
      { id: this.FTD_GRAPH, label: 'label.chart_signups_title' },
      { id: this.CASINO_GRAPH, label: 'label.chart_brand_title' },
    ];
  }

  get columnFilters() {
    return [
      { id: this.DATE_COLUMN, label: this.$t('label.date') },
      { id: this.VIEW_COLUMN, label: this.$t('label.impression') },
      { id: this.CLICKS_COLUMN, label: this.$t('label.hits') },
      { id: this.CLICK_RT_COLUMN, label: `${this.$t('label.click_conversion')}(%)` },
      { id: this.SIGNUP_COLUMN, label: this.$t('label.signups') },
      { id: this.SIGNUP_RT_COLUMN, label: `${this.$t('label.signup_conversion')}(%)` },
      { id: this.FTD_COLUMN, label: this.$t('label.ftds') },
      { id: this.FTD_RT_COLUMN, label: `${this.$t('label.ftd_conversion')}(%)` },
      { id: this.ACTIVE_COLUMN, label: this.$t('label.active_players') },
      { id: this.SALES_COLUMN, label: this.$t('label.net_revenue') },
      { id: this.COMM_COLUMN, label: `${this.$t('label.commissions')}` },
      { id: this.CPA_COMM_COLUMN, label: `${this.$t('label.cpa_commissions')}` },
      { id: this.TIER_COMM_COLUMN, label: `${this.$t('label.tier_commission')}` },
      { id: this.DEPOSITS_COLUMN, label: this.$t('label.deposits') },
      { id: this.DEPOSIT_COUNT_COLUMN, label: this.$t('label.deposit_count') },
      { id: this.WITHDRAWALS_COLUMN, label: this.$t('label.withdrawals') },
      { id: this.WITHDRAWAL_COUNT_COLUMN, label: this.$t('label.withdrawal_count') },
      { id: this.TOTAL_COMM_COLUMN, label: `${this.$t('label.total_commission')}` },
    ];
  }

  get getAllAdvertisementCategories() {
    return CommonsStore.allAdvertisementCategories;
  }

  get filteredCampaignList() {
    const { adsCategoryId } = this.state;
    if (adsCategoryId) {
      return _filter(this.campaignList, ['advertisementCategoryId', adsCategoryId]);
    }
    return this.campaignList;
  }

  get getAffiliateID() {
    let affiliate_id = AuthorizationStore.currentLoggedUserInState.id;
    if (affiliate_id === undefined || affiliate_id === null) {
      const local_json_string = localStorage.getItem('ma-auth.currentUser') as string;
      affiliate_id = JSON.parse(local_json_string).id;
    }

    return affiliate_id;
  }

  displayDate() {
    const { display, dayPeriod } = this.state;
    const lang = this.$i18n.i18next.language;
    if (display === this.BY_MONTH && (lang === 'en' || lang === 'br')) {
      return [formatDate(dayPeriod[0], 'YYYY MMMM').split(' '), formatDate(dayPeriod[1], 'YYYY MMMM').split(' ')];
    } if (display === this.BY_DAY && (lang === 'en' || lang === 'br')) {
      return [formatDate(dayPeriod[0], 'YYYY MMMM DD').split(' '), formatDate(dayPeriod[1], 'YYYY MMMM DD').split(' ')];
    } if (display === this.BY_MONTH && lang === 'jp') {
      const start = formatDate(dayPeriod[0], 'YYYY MM').split(' ');
      start[0] = `${start[0]}年`;
      start[1] = `${start[1]}月`;
      const end = formatDate(dayPeriod[1], 'YYYY MM').split(' ');
      end[0] = `${end[0]}年`;
      end[1] = `${end[1]}月`;
      return [start, end];
    }

    const start = formatDate(dayPeriod[0], 'YYYY MM DD').split(' ');
    start[0] = `${start[0]}年`;
    start[1] = `${start[1]}月`;
    start[2] = `${start[2]}日`;
    const end = formatDate(dayPeriod[1], 'YYYY MM DD').split(' ');
    end[0] = `${end[0]}年`;
    end[1] = `${end[1]}月`;
    end[2] = `${end[2]}日`;

    return [start, end];
  }

  // TODO : transfer in API side if ever
  get displayValWithBtcTooltip() {
    const self = this;
    return function (dataVal: number, btcVal: number) {
      const isBTCService = CommonsStore.isBTCService(self.state.service);
      if (isBTCService && btcVal && dataVal !== 0) {
        return true;
      }
      return false;
    };
  }

  get computedDateUtil() {
    return {
      formatDate,
      FULL_DATE_FORMAT,
      FULL_MONTH_FORMAT,
      DEFAULT_FORMAT,
    };
  }

  get computedCommonUtil() {
    return {
      getPercentageRate,
      roundMoneyAmount,
      toMoney,
    };
  }

  get displayedCommission() {
    return Math.max(this.mereports.commission || 0.00, 0.00);
  }

  get displayTotalFtd() {
    const report = this.mereports || {};
    const totalFtd = this.getFirstNumericValue(report, [
      'ftd_total'
    ]);

    return totalFtd ? totalFtd : 0;
  }

  get qualifiedFtd() {
    const report = this.mereports || {};
    const qualifiedFtd = this.getFirstNumericValue(report, [
      'ftd'
    ]);

    return qualifiedFtd ? qualifiedFtd : 0;
  }


  getFirstNumericValue(obj: any, keys: string[]) {
    for (let i = 0; i < keys.length; i += 1) {
      const value = obj[keys[i]];
      if (value === null || value === undefined || value === '') {
        continue;
      }

      const parsed = Number(value);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    return null;
  }

  get displayedTierCommission() {
    const positiveTierCommission = Math.max(Number(this.mereports.tier_commission) || 0.00, 0.00);
    return this.roundMoneyAmount(positiveTierCommission);
  }

  get hasNegativeCommission() {
    return (this.mereports.commission || 0.00) < 0;
  }

  get hasNegativeTierCommission() {
    return (this.mereports.tier_commission || 0.00) < 0;
  }

  get negativeTierCommissionRounded() {
    return this.roundMoneyAmount(this.mereports.tier_commission || 0.00, false);
  }

  roundMoneyAmount(money: number | string = 0.00, useAbsolute: boolean = false) {
    return roundMoneyAmount(money, useAbsolute);
  }

  getCasinoDescription(id: number) {
    const casino = this.activeCasinos.find((c) => c.id === id);
    return casino ? casino.code : '';
  }

  /**
    * Lifecycle hooks
    * */
  created() {
    this.getCasinoWithDaySales();
    this.search();
    CommonsStore.fetchAllCasino();
    CommonsStore.fetchAllAdsCategory();
    AdvertisementsStore.getCampaignList(new Payload({ affiliateId: AuthorizationStore.currentLoggedUserInState.id, status: 1 }));
  }

  beforeCreate() {
    this.dateUtil = {
      formatDate,
      FULL_DATE_FORMAT,
      FULL_MONTH_FORMAT,
      DEFAULT_FORMAT,
    };
    this.commonUtil = {
      getPercentageRate,
      roundMoneyAmount,
      toMoney,
    };
  }
}
